module.exports = __webpack_public_path__ + "img/icn-filter-09.f469c704.svg";